import { PAYWALL_UNLOCKED_EVENT, PaywallUnlockedEventDetail } from '../types';

/**
 * Dispatches the `benzinga:paywall:unlocked` window event. SSR-safe.
 * Fires after an Edge checkout completes, so paywall consumers can dismiss.
 */
export const emitPaywallUnlocked = (detail: PaywallUnlockedEventDetail): void => {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent<PaywallUnlockedEventDetail>(PAYWALL_UNLOCKED_EVENT, { detail }));
  } catch {
    // CustomEvent unavailable in some legacy environments — fail silent.
  }
};
